import {create} from "zustand";
import {route} from "ziggy-js";

export const useModalStore = create((set) => ({
    // Модальное окно "Хотите больше бонусов?"
    moreBonusesModalFlag: false,

    // Модальное окно "Код вашего счета"
    qrCodeBonusAccountModalFlag: false,

    // Модальное окно "Заявка на возврат, обмен или ремонт"
    refundsModalFlag: false,
    // Данные по заказу/заказам для оформления заявки на возврат
    refundsData: {},

    // Модальное окно "Профиль пользователя"
    profileDrawerFlag: false,

    /**
     * Открыть модальное окно "Хотите больше бонусов?"
     */
    openMoreBonusesModal: () => set({moreBonusesModalFlag: true}),
    /**
     * Закрыть модальное окно "Хотите больше бонусов?"
     */
    closeMoreBonusesModal: () => set({moreBonusesModalFlag: false}),

    /**
     * Открыть модальное окно "Код вашего счета"
     */
    openQrCodeBonusAccountModal: () => set({qrCodeBonusAccountModalFlag: true}),
    /**
     * Закрыть модальное окно "Код вашего счета"
     */
    closeQrCodeBonusAccountModal: () => set({qrCodeBonusAccountModalFlag: false}),

    /**
     * Открыть модальное окно "Заявка на возврат, обмен или ремонт"
     */
    openRefundsModal: () => set({refundsModalFlag: true}),
    /**
     * Закрыть модальное окно "Заявка на возврат, обмен или ремонт"
     */
    closeRefundsModal: () => set({refundsModalFlag: false, refundsData: {}}),
    /**
     * Запрос данных по заказу/заказам для оформления заявки на возврат
     * @param order_id
     * @returns {Promise<void>}
     */
    fetchRefundsData: async (order_id = null) => {
        const {data} = await axios.post(route('getRefundsData'), {order_id: order_id});
        const {success = {}} = data;
        set({refundsData: {...success.data, order_id: order_id}});
    },

    /**
     * Открыть модальное окно "Профиль пользователя"
     */
    openProfileDrawer: () => set({profileDrawerFlag: true}),
    /**
     * Закрыть модальное окно "Профиль пользователя"
     */
    closeProfileDrawer: () => set({profileDrawerFlag: false}),
}));
